<div class="progress-widget__container">
  <div class="progress-widget__header">
    <div class="progress-widget__title">
      <ng-content select="[title]"></ng-content>
    </div>

    <div class="progress-widget__actions">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
  <div class="progress-widget__content">
    <ng-content></ng-content>
  </div>
</div>
